"use client"
import { useNavigate } from "react-router-dom"
import "../../resources/scss/empty-state.scss"

const EmptyState = ({
                        type = "no-posts",
                        searchTerm = "",
                        onClearSearch = null,
                        onWritePost = null,
                        customMessage = null,
                        customDescription = null,
                        customButtonText = null,
                        redirectPath = null,
                    }) => {
    const navigate = useNavigate()

    const handleWriteClick = () => {
        if (onWritePost) {
            onWritePost()
        } else if (redirectPath) {
            navigate(redirectPath)
        } else {
            navigate("/church-news/write")
        }
    }

    const handleClearSearch = () => {
        if (onClearSearch) {
            onClearSearch()
        }
    }

    // 검색 결과 없음
    if (type === "no-search-results") {
        return (
            <div className="no-search-results">
                <div className="empty-state">
                    <div className="empty-state-icon">
                        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={1.5}
                                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                            />
                        </svg>
                    </div>
                    <h3 className="empty-state-title">검색 결과가 없습니다</h3>
                    <p className="empty-state-description">
                        '{searchTerm}'에 대한 검색 결과를 찾을 수 없습니다.
                        <br />
                        다른 검색어로 시도해보세요.
                    </p>
                    <div className="empty-state-actions">
                        <button className="empty-state-button secondary" onClick={handleClearSearch}>
                            검색 초기화
                        </button>
                    </div>
                </div>
            </div>
        )
    }

    // 게시글 없음 (기본)
    return (
        <div className="empty-state">
            <div className="empty-state-icon">
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={1.5}
                        d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z"
                    />
                </svg>
            </div>
            <h3 className="empty-state-title">{customMessage || "아직 등록된 소식이 없습니다"}</h3>
            <p className="empty-state-description">
                {customDescription || (
                    <>
                        교회의 새로운 소식과 공지사항을
                        <br />
                        가장 먼저 전해드리겠습니다.
                    </>
                )}
            </p>
            <div className="empty-state-actions">
                <button className="empty-state-button secondary" onClick={() => window.location.reload()}>
                    <i className="fas fa-refresh" style={{ marginRight: "8px" }}></i>
                    새로고침
                </button>
            </div>
        </div>
    )
}

export default EmptyState
